import { createContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";

const MasterLayoutContext = createContext();

export const MasterLayout = () => {
  const [swalProps, setSwalProps] = useState({});
  const value = {};

  return (
    <>
      <SweetAlert2
        {...swalProps}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
      />
      <MasterLayoutContext.Provider value={value}>
        <div>
          <Outlet />
        </div>
      </MasterLayoutContext.Provider>
    </>
  );
};
